const dic={
  // 机构等级
  levelCode:{
    "10001":"总部",
    "10002":"一级机构",
    "10003":"二级机构",
    "10004":"三级机构",
    "10005":"四级机构",
  },
  // 机构状态
  mechanStatus:{
    "1":"营业中",
    "2":"已关闭",
  },
}


export default dic
